import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { TextEditorValue } from '@dreryk/react-text-editor';
import { FieldController } from '@dreryk/react-common';

import { RecommendationsTextEditor } from '../../form/recommendations/RecommendationsTextEditor';
import { StyledPrescriptionVisitDataModalField } from '../PrescriptionVisitDataModal.styled';

type RecommendationsFieldProps = {
   readonly controller: FieldController<TextEditorValue | null>;
   readonly practitionerId: PractitionerId;
   readonly visitId: number;
   readonly patientId: number;
};

export const RecommendationsField = (props: RecommendationsFieldProps): JSX.Element => {
   return (
      <StyledPrescriptionVisitDataModalField>
         <RecommendationsTextEditor
            controller={props.controller}
            practitionerId={props.practitionerId}
            visitId={props.visitId}
            patientId={props.patientId}
         />
      </StyledPrescriptionVisitDataModalField>
   );
};
